import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../user-connection/user.service';
import { CallbackStore } from '../pages/callback/callback-store.service';
import { QueryParamsCallBack, QueryParamsEnum } from '../pages/callback/callback.model';
import { isAdmin } from '../helpers/user-right.helper';
import { ApplicationStore } from '../../core/services/application-store.service';

export const authGuard: CanActivateFn = (_, state) => {
  const userService = inject(UserService);
  const callbackStore = inject(CallbackStore);
  const applicationStore = inject(ApplicationStore);
  const stateUrls = state.url.split('?');
  const urlSearchParams = new URLSearchParams(stateUrls[1]);
  const queryParamKeys: Record<QueryParamsEnum, string> = {
    [QueryParamsEnum.LOGIN_HINT]: 'login_hint',
    [QueryParamsEnum.INDEX]: 'index',
    [QueryParamsEnum.POS]: 'pos',
    [QueryParamsEnum.SELLER]: 'seller',
    [QueryParamsEnum.CCK_NUMBER]: 'cckNumber',
    [QueryParamsEnum.CLIENT_NAME]: 'clientName',
    [QueryParamsEnum.SORT_PROPERTY]: 'sortProperty',
    [QueryParamsEnum.SORT_DIRECTION]: 'sortDirection'
  };
  let queryParams: QueryParamsCallBack = {};
  for (const param of urlSearchParams) {
    const name = param[0];
    const value = param[1];
    const key = queryParamKeys[name as QueryParamsEnum];
    if (key) {
      queryParams = {
        ...queryParams,
        [key]: value
      };
    }
  }
  const baseUri = stateUrls[0].split('/').splice(1);
  callbackStore.update(baseUri, queryParams);
  if (!userService.isUserConnected()) {
    return false;
  }
  return !(baseUri[0] === 'administration' && !isAdmin(applicationStore.instant('userData')()?.userRights));
};
